import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
// import LeftNav from "../../../../components/common/nav/admin/nav.component";
// import TopNav from "../../../../components/common/nav/admin/top.component";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { DataTableCustomStyles } from "../../../../../helper/dataTable.config";
// import AdminLogin from "../../../../setup/auth/admin.component";
import { Auth } from "aws-amplify";
import * as alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";
import AWS from "aws-sdk";
import awsmobile from "../../../../../aws-exports";
import { GetValueFromArray } from "../../../../../helper/commonfunctions";
import moment from "moment";
import { USER_TYPES, USER_TYPES_NAMES } from "../../../../../helper/enum";
import { SendLoginUsernameAndPassword } from "../../../../../helper/mail";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import DeleteButton from '../../../../../components/buttons/DeleteButton';
import ResetPasswordButton from '../../../../../components/buttons/ResetPasswordButton'
import { DataStore } from '@aws-amplify/datastore';
// import { InterpreterRequests } from '../../../../../models'
import { ValidateAdminRole } from '../../../../../helper/validateRole';
import PermissionButton from "../../../../../components/buttons/PermissionButton";
import Login from "../../../../../setup/auth/login.component";
import Layout from "../../../../../components/common/nav/admin/nav.component";
import EditButton from "../../../../../components/buttons/EditButton";
import { Tag } from "primereact/tag";
import { API, graphqlOperation } from 'aws-amplify';
import * as queries from '../../../../../graphql/queries';

export default function Users() {
  //SET AWS Configuration
  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
    secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
    region: process.env.REACT_APP_AWS_Region,
  });

  const roleList = [
    { value: "", label: "Role" },
    { value: "U", label: "User" },
    { value: "A", label: "Admin" },
  ];

  const statusList = [
    { value: "", label: "Status" },
    { value: "CONFIRMED", label: "Confirmed" },
    { value: "RESET_REQUIRED", label: "Reset Required" },
    { value: "UNCONFIRMED", label: "Unconfirmed" },
    { value: "FORCE_CHANGE_PASSWORD", label: "Force Change Password" },
  ];


  const defaultSearchFields = [
    { value: "", label: "Search On" },
    { value: "email", label: "Email" },
    { value: "name", label: "Name" },
  ];

  const [selectedRole, setSelectedRole] = useState("");
  const [searchStatus, setSelectedStatus] = useState("");
  const [selectedSearchBy, setSelectedSearchBy] = useState("");
  const [searchExpression, setSearchExpression] = useState("");
  const [selectedSearchLabel, setSelectedSearchLabel] = useState("");
  const [statusLabel, setStatusLabel] = useState("");
  const [loading, setLoading] = useState(true);
  const [showPleaseWaitButton, setPleaseWaitButton] = useState(false);

  let navigateTo = useNavigate();


  const sendLoginEmail = async (e) => {


    e.preventDefault();

    let allData = [];
    let nextToken4 = null;
    let hasMoreData = true;
    while (hasMoreData) {
      const result2 = await API.graphql(graphqlOperation(queries.listLoginEmails, { limit: 1000, nextToken: nextToken4 }));
      const { items, nextToken: newNextToken } = result2.data.listLoginEmails;

      allData = [...allData, ...items];
      nextToken4 = newNextToken;
      hasMoreData = nextToken4 !== null && nextToken4 !== undefined ? nextToken4 : false;
    }
    allData = allData.filter(item => item._deleted !== true);

    if (allData.length > 100) {
      hasMoreData = false
    }
    else {
      hasMoreData = nextToken4 !== null && nextToken4 !== undefined ? nextToken4 : false;
    }

    if (allData.length > 0) {
    }
    setPleaseWaitButton(true)
    //grab the dialog instance using its parameter-less constructor then set multiple settings at once.
    alertify.confirm(
      "Confirmation",
      "Do you want to send user credentials?",
      async function () {
        console.log('allData', allData)

        allData.map((item, index) => {
          SendLoginUsernameAndPassword(item.firstName, item.email, item.password)
        })
        setPleaseWaitButton(false)
        toast.success("User credentials has been send successfully.");
      },
      function () {
        setPleaseWaitButton(false)
      },
      
    );

  };



  const handleResetPasswordClick = (e, id) => {
    e.preventDefault();

    const cognito = new AWS.CognitoIdentityServiceProvider();
    var params = { UserPoolId: awsmobile.aws_user_pools_id, Username: id };

    alertify.confirm(
      "Confirmation",
      "Do you want to reset this user password?",
      function () {
        cognito.adminResetUserPassword(params, (err, data) => {
          if (err) {
            toast.error(err.message);
          } else {
            toast.success("New password email has been send successfully.");
            LoadUsers();
          }
        });
      },
      function () { }
    );
  };

  const handleDeleteClick = async (e, id) => {
    e.preventDefault();

    const cognito = new AWS.CognitoIdentityServiceProvider();
    var params = { UserPoolId: awsmobile.aws_user_pools_id, Username: id };

    alertify.confirm(
      "Confirmation",
      "Do you want to delete this user?",
      async function () {
        //Delete Existing InterpreterRequest for the User
        // DataStore.delete(InterpreterRequests, (c) => c.userId("eq", id))
        cognito.adminDeleteUser(params, (err, data) => {
          if (err) {
            toast.error(err.message);
          } else {

            toast.success("Deleted");
            LoadUsers();
          }
        });
      },
      function () { }
    );
  };


  //Edit Parent
  const handleEditClick = (e, id) => {
    e.preventDefault();
    navigateTo('/admin/setting/masters/createusers/' + id);
  };

  //*Column Name
  const DataTableColumns = [
    {
      name: "Role",
      selector: (row) =>
        GetValueFromArray(row.Attributes, "custom:role") === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A
          : GetValueFromArray(row.Attributes, "custom:role") === USER_TYPES.INITIATOR ? USER_TYPES_NAMES.I :
            GetValueFromArray(row.Attributes, "custom:role") === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP :
              GetValueFromArray(row.Attributes, "custom:role") === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.U,
      sortable: true,
      width: "100px",

    },

    {
      name: "First Name",
      selector: (row) => GetValueFromArray(row.Attributes, "custom:firstName"),
      sortable: true,
    },
    {
      name: "Last Name",
      selector: (row) => GetValueFromArray(row.Attributes, "custom:lastName"),
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => GetValueFromArray(row.Attributes, "email"),
      sortable: true,
    },
    {
      name: "Status",
      //selector: (row) => row.UserStatus,
      cell: (row) => (
        row.UserStatus === "CONFIRMED" ? <p className="badge-approved">{row.UserStatus}</p> :
          <p className="badge-others">{row.UserStatus}</p>
      ),
      sortable: true,
      center: true,
    },
    {
      name: "Created",
      selector: (row) =>
        moment(row.UserCreateDate).format("MM/DD/YYYY hh:mm A").toString(),
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (

        <>
          <div className="flex gap-4">
            {/* <button type="button" onClick={() => navigateTo("/admin/settings/userappspermission/", { state: { userId: row.Username, userName: GetValueFromArray(row.Attributes, "custom:firstName") + " " + GetValueFromArray(row.Attributes, "custom:lastName") } })}> */}
            {/* <PermissionButton /> */}
            {/* </button> */}

            <button type="button" onClick={(e, id) => navigateTo("/admin/setting/masters/createusers/" + row.Username, {
              state: {
                userId: row.Username,
                userSubId: GetValueFromArray(row.Attributes, "sub"),
                firstName: GetValueFromArray(row.Attributes, "custom:firstName"),
                lastName: GetValueFromArray(row.Attributes, "custom:lastName"),
                email: GetValueFromArray(row.Attributes, "email"),
                role: GetValueFromArray(row.Attributes, "custom:role"),
                UserCode: GetValueFromArray(row.Attributes, "custom:userCode"),
                mobileNumber: GetValueFromArray(row.Attributes, "custom:mobileNumber"),
                gender: GetValueFromArray(row.Attributes, "custom:gender"),
                address: GetValueFromArray(row.Attributes, "custom:address"),
                country: GetValueFromArray(row.Attributes, "custom:countryId"),
                state: GetValueFromArray(row.Attributes, "custom:stateId"),
                city: GetValueFromArray(row.Attributes, "custom:city"),
                birthDate: GetValueFromArray(row.Attributes, "custom:dateOfBirth"),
                l1authority: GetValueFromArray(row.Attributes, "custom:L1_authoritys"),
                l2authority: GetValueFromArray(row.Attributes, "custom:L2_authoritys"),
                userType: GetValueFromArray(row.Attributes, "custom:userType"),
                reportingManagerId: GetValueFromArray(row.Attributes, "custom:reportingManagerId"),
                SPReportingManager: GetValueFromArray(row.Attributes, "custom:SPReportingManager"),
                schoolId: GetValueFromArray(row.Attributes, "custom:schoolId"),

                //War Cert access
                isWARCertSAdmin: GetValueFromArray(row.Attributes, "custom:isWARCertSAdmin"),

                //Sub Req Cert access
                isSubCertSAdmin: GetValueFromArray(row.Attributes, "custom:isSubCertSAdmin"),

                //six-period access
                sixPeriodIsInitiator: GetValueFromArray(row.Attributes, "custom:sixPeriodIsInitiator"),
                sixPeriodIsApprover: GetValueFromArray(row.Attributes, "custom:sixPeriodIsApprover"),
                sixPeriodIsPayroll: GetValueFromArray(row.Attributes, "custom:sixPeriodIsPayroll"),
                sixPeriodIsSuperadmin: GetValueFromArray(row.Attributes, "custom:isSixPeriodSAdmin"),

                //time report
                timeRIsInitiator: GetValueFromArray(row.Attributes, "custom:timeRIsInitiator"),
                timeRIsApprover: GetValueFromArray(row.Attributes, "custom:timeRIsApprover"),
                timeRIsPayroll: GetValueFromArray(row.Attributes, "custom:timeRIsPayroll"),

                //personnel-action access
                personnelIsInitiator: GetValueFromArray(row.Attributes, "custom:personnelIsInitiator"),
                personnelIsApprover: GetValueFromArray(row.Attributes, "custom:personnelIsApprover"),
                personnelIsPayroll: GetValueFromArray(row.Attributes, "custom:personnelIsPayroll"),
                ispersonnelIsAdmin: GetValueFromArray(row.Attributes, "custom:ispersonnelIsAdmin"),

                //personnel-action access
                certiSubRIsInitiator: GetValueFromArray(row.Attributes, "custom:certiSubRIsInitiator"),
                certiSubReIsApprover: GetValueFromArray(row.Attributes, "custom:certiSubReIsApprover"),
                certiSubReqIsPayroll: GetValueFromArray(row.Attributes, "custom:certiSubReqIsPayroll"),

              }
            })}>
              <EditButton />
            </button>
            {
              row.UserStatus === "CONFIRMED" ?
                <Link onClick={(e) => handleResetPasswordClick(e, row.Username)}>
                  <ResetPasswordButton />
                </Link>
                : <Link to={""}>
                  <ResetPasswordButton />
                </Link>
            }
            <Link onClick={(e) => handleDeleteClick(e, row.Username)}>
              <DeleteButton />
            </Link>
          </div>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      center: true,
      width: "200px",
    },
  ];

  //Validate User Logged In
  const [isAuthenticated, userHasAuthenticated] = useState(true);

  //State
  const [users, SetUsersList] = useState([]);


  async function LoadUsers() {

    try {
      const cognito = new AWS.CognitoIdentityServiceProvider();

      //Status
      if (searchStatus !== '') {
        var params =
        {
          UserPoolId: awsmobile.aws_user_pools_id,
          Limit: 60
        };
        params['Filter'] = "cognito:user_status='" + searchStatus + "'";
      }
      else if (searchExpression !== '' && selectedSearchBy !== '') //Global Search 
      {
        var params =
        {
          UserPoolId: awsmobile.aws_user_pools_id,
          Limit: 60
          //"Filter": "email ^= \""+searchExpression+"\""
        };

        params['Filter'] = selectedSearchBy + "^= \"" + searchExpression + "\""
      } else {
        var params =
        {
          UserPoolId: awsmobile.aws_user_pools_id,
          Limit: 60
        };
      }
      cognito.listUsers(params, (err, data) => {
        if (err) {
          toast.error(err.message);
        } else {
          console.log(data.Users)
          SetUsersList(data.Users);
          setLoading(false);
        }
      });


    } catch (e) {
      toast.error(e.message);
    }

  }

  async function onLoad() {
    try {
       await Auth.currentSession();
       if (!ValidateAdminRole()) { userHasAuthenticated(false); }
    } catch (e) {
       console.log("error-->", e)
       userHasAuthenticated(false);
    }
 }

  useEffect(() => {
    LoadUsers();
    onLoad();
  }, [selectedRole, searchExpression, searchStatus]);

  return isAuthenticated ? (
    <Layout pageTitle="Dashboard">
      <div>
        <div className="">
          {/* <TopNav />
        <LeftNav /> */}
          <div className="dashboard-main-wrapper mt-2">
            <div className="flex flex-1 flex-wrap p-5 pb-0 px-0 top-action-wrapper">
              <div className="md:flex xs:w-full sm:w-full md:w-auto flex-row align-center">
                <div className="md:flex block md:col-span-2 mb-4"></div>
                <div className="md:flex block mb-4">
                  <h2 className="page-title">Users
                    <Tag severity="" value={`${users.length} Roles`} style={{ background: '#EFF8FF', color: '#0487C8', fontSize: 11, fontWeight: 500, padding: '0px 15px', height: 10 }} rounded></Tag>
                  </h2>
                </div>
              </div>

              <div className="md:flex flex-1 flex-row xs:w-full sm:w-full md:w-auto align-center justify-end md:ml-auto gap-3 right-side">
                <div className="md:flex block mb-4 gap-4">
                  <Link
                    to="/masters"
                    className="flex py-2 px-5 bg-[#FFF] hover:bg-blue-0 focus:ring-blue-500 focus:ring-offset-blue-200 text-black transition ease-in duration-200 text-[14px] text-center font-medium drop-shadow shadow-md focus:outline-none focus:ring-1 focus:ring-offset-1 leading-6  justify-center rounded-md border-1 border-[#1570EF] dark:bg-[#333231] dark:text-[#FFFFFF]"
                  >
                    Back
                  </Link>
                  <Link
                    to="/admin/setting/masters/createusers"
                    className="flex py-2 px-5 bg-btn-blue hover:bg-blue-0 focus:ring-blue-500 focus:ring-offset-blue-200 text-white transition ease-in duration-200 text-[14px] text-center font-medium drop-shadow shadow-md focus:outline-none focus:ring-1 focus:ring-offset-1 leading-6  justify-center rounded-md border-1 border-[#1570EF] bg-[#113699]"
                  >
                    Create
                  </Link>
                  <Link
                    onClick={(e) => sendLoginEmail(e)}
                    className="flex py-2 px-5 bg-btn-blue hover:bg-blue-0 focus:ring-blue-500 focus:ring-offset-blue-200 text-white transition ease-in duration-200 text-[14px] text-center font-medium drop-shadow shadow-md focus:outline-none focus:ring-1 focus:ring-offset-1 leading-6  justify-center rounded-md border-1 border-[#1570EF] bg-[#113699]"
                  >
                    {showPleaseWaitButton ? "Please wait..." : "Send Login E-mail"}

                  </Link>
                </div>
              </div>
            </div>

            <div className="md:flex align-center justify-end md:ml-auto gap-1.5 col-span-6">

              <div className="mt-1">
                <Select options={defaultSearchFields} maxMenuHeight={200} placeholder="Search On" onChange={(e) => {
                  setSelectedSearchBy(e.value); setSelectedSearchLabel(e);
                }} value={selectedSearchLabel ? selectedSearchLabel : { label: "Search On", value: "" }} />
              </div>

              <div >
                <input
                  type="text"
                  onChange={(e) => {
                    setSearchExpression(e.target.value);
                  }}
                  className="text-[15px] rounded-lg  flex-1  border border-[#D0D5DD] w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-500 shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 mt-1 placeholder:text-[#667085] dark:bg-[#333231] dark:border-[#333231]"
                  placeholder="Search"
                />
              </div>

              <div style={{ display: 'none' }} >
                <DatePicker
                  placeholderText="Registered Date"
                  isClearable
                  className="w-full  border border-[#D0D5DD] w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-500 shadow-sm text-[16px] focus:outline-none focus:ring-1 focus:ring-blue-500 mt-2 placeholder:text-[#667085] rounded-md text-sm dark:bg-[#333231] dark:border-[#333231]"
                />
              </div>
              <div className="mt-1" style={{ display: 'none' }} >
                <Select maxMenuHeight={200} placeholder="Role" options={roleList}
                  onChange={(e) => {
                    setSelectedRole(e.value);
                  }} />
              </div>

              <div className="mt-1">
                <Select options={statusList} width='200px' maxMenuHeight={300} placeholder="Status" onChange={(e) => {
                  setSelectedStatus(e.value); setStatusLabel(e);
                }} value={statusLabel ? statusLabel : { label: "Status", value: "" }} />
              </div>
            </div>
            <div>
              <div className={"block w-full pt-5"}>
                {
                  <DataTable
                    columns={DataTableColumns}
                    data={users}
                    customStyles={DataTableCustomStyles}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                  />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  ) : (
    <Login sessionExpired={1} />
  );
}
